import React, { useState } from 'react'
import styled from 'styled-components'
import PreviewImagePNG from '../../../../assets/images/dummyImage.jpg'


const Container = styled.div`
width: 100%;
height: 100%;
display: flex;
align-items: center;
justify-content: center;
position: fixed;
top: 0;
left: 0;
z-index: 1000;
background-color: rgba(0, 0, 0, 0.8);
`;
const Popup = styled.div`
background-color: transparent;
display: inline-flex;
position: relative;
max-width: 90vw;
max-height: 90vh;
`;
const Image = styled.img`
max-width: 90vw;
max-height: 90vh;
object-fit: contain;
display: block;
`;

const WatermarkOverlay = styled.img`
  position: absolute;
  bottom: 14px;
  right: 14px;
  width: 18%;
  min-width: 64px;
  max-width: 160px;
  max-height: 120px;
  object-fit: contain;
  opacity: 0.8;
  pointer-events: none;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  z-index: 15;
`

const CloseButton = styled.p`
float:right;
position: absolute;
top:40px;
right:30px;
font-size:25px;
font-weight:bold;
color:white;
background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
padding:10px 15px;
border-radius:50%;
border:none;
cursor: pointer;
`;


interface SingleImageModalProps {
    imageUrl: string;
    thumbnailUrl?: string;
    onClose: () => void;
    activateWatermark?: boolean;
    watermarkUrl?: string;
}
const SingleImageModal: React.FC<SingleImageModalProps> = ({ 
    thumbnailUrl, 
    imageUrl, 
    onClose,
    activateWatermark,
    watermarkUrl
}) => {
    const [url, setUrl] = useState(thumbnailUrl);
    const [load, setLoad] = useState(false);

    return (
        <Container>
            <Popup>
                <CloseButton onClick={(e) => {
                    console.log("called....")
                    e.stopPropagation();
                    onClose()
                }}>X</CloseButton>
                <Image src={!load ? thumbnailUrl ? thumbnailUrl : PreviewImagePNG : imageUrl} onLoad={() => setLoad(true)} />
                {activateWatermark && watermarkUrl && (
                    <WatermarkOverlay
                        src={watermarkUrl}
                        alt="Watermark"
                    />
                )}
            </Popup>
        </Container>
    )
}

export default SingleImageModal
